
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { Book } from 'lucide-react';

const Header = () => {
  // Add cursor effect functionality
  useEffect(() => {
    // Create cursor dot and ring elements if they don't exist
    let cursorDot = document.querySelector('.cursor-dot');
    let cursorRing = document.querySelector('.cursor-ring');
    let cursorOuterFlare = document.querySelector('.cursor-outer-flare');
    
    if (!cursorDot) {
      cursorDot = document.createElement('div');
      cursorDot.classList.add('cursor-dot');
      document.body.appendChild(cursorDot);
    }
    if (!cursorRing) {
      cursorRing = document.createElement('div');
      cursorRing.classList.add('cursor-ring');
      document.body.appendChild(cursorRing);
    }
    if (!cursorOuterFlare) {
      cursorOuterFlare = document.createElement('div');
      cursorOuterFlare.classList.add('cursor-outer-flare');
      document.body.appendChild(cursorOuterFlare);
    }

    // Function to move cursor elements
    const moveCursor = (e: MouseEvent) => {
      (cursorDot as HTMLElement).style.left = `${e.clientX}px`;
      (cursorDot as HTMLElement).style.top = `${e.clientY}px`;
      (cursorRing as HTMLElement).style.left = `${e.clientX}px`;
      (cursorRing as HTMLElement).style.top = `${e.clientY}px`;
      (cursorOuterFlare as HTMLElement).style.left = `${e.clientX}px`;
      (cursorOuterFlare as HTMLElement).style.top = `${e.clientY}px`;
    };

    // Add event listener for cursor movement
    document.addEventListener('mousemove', moveCursor);

    // Handle cursor hover effects
    const handleMouseEnter = () => {
      (cursorRing as HTMLElement).style.width = '40px';
      (cursorRing as HTMLElement).style.height = '40px';
      (cursorRing as HTMLElement).style.borderColor = '#22D3EE';
      (cursorOuterFlare as HTMLElement).style.borderColor = 'rgba(34, 211, 238, 0.4)';
    };
    
    const handleMouseLeave = () => {
      (cursorRing as HTMLElement).style.width = '32px';
      (cursorRing as HTMLElement).style.height = '32px';
      (cursorRing as HTMLElement).style.borderColor = 'transparent';
      (cursorOuterFlare as HTMLElement).style.borderColor = 'rgba(125, 211, 252, 0.3)';
    };

    // Add hover effect to all interactive elements
    document.querySelectorAll('a, button, input, select, textarea').forEach(el => {
      el.addEventListener('mouseenter', handleMouseEnter);
      el.addEventListener('mouseleave', handleMouseLeave);
    });

    // Clean up
    return () => {
      document.removeEventListener('mousemove', moveCursor);
      document.querySelectorAll('a, button, input, select, textarea').forEach(el => {
        el.removeEventListener('mouseenter', handleMouseEnter);
        el.removeEventListener('mouseleave', handleMouseLeave);
      });
    };
  }, []);

  return (
    <header className="py-4 px-6 flex justify-between items-center">
      <div className="flex items-center space-x-6">
        <Link to="/" className="flex items-center">
          <div className="font-bold text-xl bg-gradient-to-r from-whirlpool-cyan to-whirlpool-blue bg-clip-text text-transparent">
            WhirlPool
          </div>
        </Link>
        
        <Link to="/docs" className="flex items-center space-x-1 text-whirlpool-cyan hover:text-whirlpool-blue transition-colors">
          <Book size={16} />
          <span>Docs</span>
        </Link>
      </div>
      <WalletMultiButton />
    </header>
  );
};

export default Header;
